var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psCalendarGrid"},[_c('ps-calendar-upper-bar',{attrs:{"site":{ site: 'Calendario' }}}),_c('div',{staticClass:"container"},_vm._l((_vm.calendar),function(calendarMonth,index){return _c('ps-calendar-grid-month',{key:index,attrs:{"calendar-month":calendarMonth,"index":index}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }